import { PaymentOption, WashingOption } from "../../types/washing.types";
import { PAGES, PAYMENT_TYPES, TotemWashingStoreState, WashingStoreInteraction } from "./WashingStore.types";

export const paymentOptions: PaymentOption[] = [
  {
    type: PAYMENT_TYPES.CARD_DEBIT,
    title: "Cartão de Débito",
  },
  {
    type: PAYMENT_TYPES.CARD_CREDIT,
    title: "Cartão de Crédito",
  },
];

// Mocks

export const mockOptions: WashingOption[] = [
  {
    id: "teste",
    washingId: "L1",
    type: "CAR",
    name: "Lavagem Básica",
    price: 10.00,
    estimatedTime: 30,
    stations: []
  },
  {
    id: "teste",
    washingId: "L2",
    type: "VAN",
    name: "Lavagem Básica 2",
    price: 15.00,
    estimatedTime: 45,
    stations: []
  },
];

export const defaultWashing = {
  id: "teste",
  washingId: "L1",
  type: "CAR",
  name: "Lavagem Básica",
  price: 10.00,
  estimatedTime: 30
}

export const washingStoreInteraction: WashingStoreInteraction = {
  currPage: PAGES.START_PAGE,
  selectedWashing: {} as WashingOption,
  selectedPayment: {} as any,
  errorMsg: "",
  finalPrice: 0,
  paymentId: "",
  cieloTransactionId: "",
  taxId: "",
}

export const washingStoreState: TotemWashingStoreState = {
  ...washingStoreInteraction,
  washingOptions: [],
  totemId: "",
  terminalId: "",
};
